export default {
    employeeManagement: 'Employee management',
    importEmployeeList: 'Import Employee list',
    employeeList: 'Employee list',
    employeeImage: 'Employee Image'
}
